import React from 'react';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import Content from './Components/Content/Content';

const Login = () => {
    return (
        <div>
            <Header />
            <Content />
            <Footer />
        </div>
    );
}

export default Login;
